import { observer } from 'mobx-react-lite';
import { FC, ReactElement } from 'react';
import { FormSpy } from 'react-final-form';

import { Field, Form, IFormContentProps, RadioGroup, TextField } from '@gem/components';
import { useTranslation } from '@gem/modules/i18n';
import { Button, ButtonTypes, PopupFooter } from '@gem/ui-kit';

import { useNewRecordingPresenter, INewRecordingParams } from './NewRecording.presenter';
import styles from './NewRecording.styles.m.css';

export const NewRecording: FC<INewRecordingParams> = observer((props) => {
  const { t } = useTranslation();
  const presenter = useNewRecordingPresenter(props);

  return (
    <>
      <Form
        onSubmit={presenter.onSubmit}
        initialValues={presenter.initialValues}
      >
        {({ handleSubmit }: IFormContentProps): ReactElement => (
          <form
            onSubmit={handleSubmit}
            id={'newRecording'}
            className={styles.container}
          >
            <div className={styles.content}>
              <Field
                isNeedTrim
                name="title"
                label={t('calls_recording_title_recording_screen')}
                component={TextField}
                maxLength={300}
                validatingText={''}
                successText={''}
              />
              <RadioGroup
                className={styles.recordingType}
                name="recordingType"
                title={t('calls_recording_type_title_recording_screen')}
                options={presenter.recordingOptions}
              />
            </div>
            <FormSpy onChange={presenter.checkValid} />
          </form>
        )}
      </Form>
      <PopupFooter>
        <Button
          type={ButtonTypes.Submit}
          form={'newRecording'}
          theme="primary"
          isDisabled={!presenter.isValid || presenter.isSubmitting}
        >
          {t('calls_recording_start_button')}
        </Button>
      </PopupFooter>
    </>
  );
});
